import { getIsSteamTopSellers } from '../../../utils';
import {
  // 时间筛选器
  RANGE_TIME as FILTER_RANGE_TIME,
  // 组合下拉筛选器
  COMPOSED_SELECT as FILTER_COMPOSED_SELECT,
  // 级联国家筛选器
  REGION as FILTER_REGION,
} from '@/pages/intelligence/components/Filter/FilterBase/_config';
import { PC_PLATFORM_STEAM, PC_TOP_TOP_SELLERS } from '@/pages/intelligence/_config/storeRank/config';

export const getComposedChangedApiValue = (apiValue: any): any => {
  const platformTop = apiValue?.[FILTER_COMPOSED_SELECT]?.value ?? {};
  // 是否为Steam Top Seller
  const isSteamTopSellers = getIsSteamTopSellers({
    platform: platformTop?.parent ?? PC_PLATFORM_STEAM,
    top: platformTop?.child ?? PC_TOP_TOP_SELLERS,
  });
  if (isSteamTopSellers) return apiValue;

  return {
    ...apiValue,
    [FILTER_RANGE_TIME]: {
      ...apiValue?.[FILTER_RANGE_TIME],
      filterType: 'date',
      time_type: 'day',
      granularity: 'daily',
    },
    [FILTER_REGION]: {
      ...apiValue?.[FILTER_REGION],
      filterType: 'market',
      filterRegions: [],
      filterMarkets: ['global'],
      region_type: 'region',
      regions: ['global'],
      markets: ['global'],
      realMarkets: [],
      region_values: ['global'],
    },
  };
};
